import CompleteTaskForCaseButton from "@/components/CompleteTaskForCaseButton.tsx";
import { useCaseTask } from "@/contexts/CaseTasksProvider.tsx";
import { Alert, Stack } from "@mui/material";

type Props = {
    caseUUID: string;
    caseStatus: string;
};

const CaseTasksForTab = ({ caseUUID, caseStatus }: Props) => {
    const { caseTasksPending } = useCaseTask();
    const tasksForTab = caseTasksPending.filter((task) => task.caseStatuses.includes(caseStatus));

    return (
        <Stack
            sx={{
                p: 1,
                width: "100%",
            }}
        >
            {tasksForTab.map((caseTask) => (
                <Alert
                    key={caseTask.idUUID}
                    severity={caseTask.overdue ? "error" : "info"}
                    sx={{
                        mb: 1,
                        width: "100%",
                        "& .MuiAlert-icon": {
                            alignItems: "center",
                        },
                        "& .MuiAlert-message": {
                            width: "100%",
                        },
                    }}
                >
                    <Stack
                        sx={{
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexDirection: "row",
                        }}
                    >
                        {`${caseTask.name} - Due ${
                            caseTask.duration === 0 ? "N/A" : caseTask.dueDate.toLocaleDateString()
                        }${caseTask.overdue ? " (Overdue)" : ""}`}
                        <CompleteTaskForCaseButton
                            caseTaskUUID={caseTask.idUUID}
                            caseStatus={caseStatus}
                            caseUUID={caseUUID}
                            taskName={caseTask.name}
                            dueDate={caseTask.dueDate}
                            description={caseTask.description}
                            caseTask={caseTask}
                        />
                    </Stack>
                </Alert>
            ))}
        </Stack>
    );
};

export default CaseTasksForTab;
